import Head from "next/head";
import Layout from "../components/Layout";
import Flatpage from "../components/Flatpage";

const DoNotSellMyInfo = () => {
  return (
    <Layout noAds>
      <Head>
        <title>Do Not Sell My Info - AppCheeta</title>
      </Head>
      <Flatpage>
        <h1>Do Not Sell My Info</h1>
        <p>Last updated: February 04, 2020</p>
        <p>
          If you are a Californian resident you have the right to opt out of the sale of your
          personal info and request what companies or categories of companies we have sold your
          personal information to.
        </p>
        <p>
          Send us a message through our <a href="/contact">Contact</a> an email to info@appcheeta.com
          with the following information:
        </p>
        <p>
          Why you are contacting us. For example, to opt out of the sale of personal info. To
          request what companies of categories of companies we have sold your personal information
          to.
        </p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
        </ul>
        <p>
          All requests to opt out will be processed and you will receive a notification by email.
        </p>
        <p>
          To learn more about how your personal information may be used on our site please visit our{" "}
          <a href="/privacy">Privacy Policy</a>.
        </p>
      </Flatpage>
    </Layout>
  );
};

export default DoNotSellMyInfo;
